<template>
  <div>
    <button
      type="button"
      class="btn btn-primary btn-with-addon"
      @click="showModal"
    >
      <span class="btn-addon">
        <i class="btn-addon-icon fe fe-plus-circle" />
      </span>
      Create Exam Setting
    </button>
    <a-modal v-model="visible" title="Add a new exam setting">
      <template slot="footer">
        <a-button key="back" @click="handleCancel">Cancel</a-button>
        <a-button
          key="submit"
          type="primary"
          :loading="loading"
          @click="handleSubmit"
          >Add Exam Setting</a-button
        >
      </template>

      <a-form class="mb-4" :form="form">
        <!-- Name -->
        <a-form-item label="Name">
          <a-input
            placeholder="Name"
            v-decorator="[
              'name',
              {
                rules: [
                  { required: true, message: 'Please input exam setting name!' }
                ]
              }
            ]"
          />
        </a-form-item>

        <!-- Score -->
        <a-form-item label="% score to give rankings upto">
          <a-input-number
            placeholder="% score to give rankings upto"
            v-decorator="[
              'score_to_give_rankings',
              {
                rules: [
                  {
                    required: true,
                    message: 'Please input % score to give rankings upto!'
                  }
                ]
              }
            ]"
            style="width:470px"
          />
        </a-form-item>

        <!-- Max Rank -->
        <a-form-item label="Maximum ranks allowed">
          <a-input-number
            placeholder="Maximum ranks allowed"
            v-decorator="[
              'max_ranks_allowed',
              {
                rules: [{ required: true, message: 'Please input maximum ranks allowed!' }]
              }
            ]"
            style="width:470px"
          />
        </a-form-item>

        <!-- Include Attendance -->
        <a-form-item label="Include Attendance">
          <a-radio-group
            v-decorator="[
              'include_attendance',
              {
                rules: [{ required: true, message: 'This value is required' }],
                initialValue: 0
              }
            ]"
          >
            <a-radio :value="1">Yes</a-radio>
            <a-radio :value="0">No</a-radio>
          </a-radio-group>
        </a-form-item>

        <!-- Description -->
        <a-form-item label="Description">
          <a-textarea
            placeholder="Description"
            :autosize="{ minRows: 2 }"
            v-decorator="['description']"
          />
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
export default {
  name: 'AddExamSetting',
  data: function() {
    return {
      form: this.$form.createForm(this),
      loading: false,
      visible: false,
    }
  },
  methods: {
    showModal() {
      this.visible = true
    },

    handleSubmit(e) {
      this.loading = true
      this.form.validateFields((err, values) => {
        if (!err) {
          this.$confirm({
            title: `Are you sure you want to add ${values.name}?`,
            content: `Click on the OK button to add the new exam setting!`,
            onOk: () => {
              this.$http
                .post('/api/exam/settings', {
                  name: values.name,
                  description: values.description,
                  score_to_give_rankings: values.score_to_give_rankings,
                  max_ranks_allowed: values.max_ranks_allowed,
                  include_attendance: values.include_attendance,
                })
                .then(({ data }) => {
                  // console.log(data.data);
                  this.$emit('created')
                  this.loading = false
                  this.visible = false
                  this.$notification['success']({
                    message: 'Exam setting successfully added',
                    description: `${data.data.name} added successfully!`,
                  })
                  this.form.resetFields()
                })
                .catch(error => {
                  this.loading = false
                  this.$neoNotify.error(error)
                })
            },
            onCancel: () => {
              this.loading = false
            },
          })
        }

        this.loading = false
      })
    },
    handleCancel(e) {
      this.form.resetFields()
      this.visible = false
    },
  },
}
</script>
